import { useMemo } from 'react';

import axios, { Axios } from 'axios';

import { oimApiConfig } from '../../config';
import { useAuthorization } from '../../utils/Api';

export interface SearchOimContactParams {
  email?: string;
  phone?: string;
}

class OimApiProxyService {
  constructor(private readonly http: Axios) {}

  searchOimContact(params: SearchOimContactParams) {
    return this.http.get('/oim-api-proxy/contacts', { params });
  }
}

export const useOimApiProxyService = () => {
  const http = axios.create({
    baseURL: oimApiConfig.apiBaseUrl,
  });

  useAuthorization(http);

  return useMemo(() => new OimApiProxyService(http), [http]);
};
